import { SvgIcon, SvgIconProps } from '@mui/material';
import { OverridableComponent } from '@mui/material/OverridableComponent';
import { SvgIconTypeMap } from '@mui/material/SvgIcon';

// Regular Expression icon from assets/classifier-icons/regex.svg
const RegexIcon = (props: SvgIconProps) => {
  return (
    <SvgIcon {...props} viewBox="0 0 24 24" fill="none">
      <path
        fill="currentColor"
        d="M4.925 19.02505c-0.9 -0.96665 -1.6125 -2.05415 -2.1375 -3.2625C2.2625 14.5542 2 13.2917 2 11.97505c0 -1.33335 0.254165 -2.60415 0.7625 -3.8125 0.508335 -1.20835 1.229165 -2.2875 2.1625 -3.2375l1.075 1.05c-0.8 0.8 -1.416665 1.71665 -1.85 2.75s-0.65 2.11665 -0.65 3.25c0 1.11665 0.225 2.18335 0.675 3.2 0.45 1.01665 1.05835 1.94165 1.825 2.775l-1.075 1.075Zm4.575 -1.275c-0.35 0 -0.64585 -0.12085 -0.8875 -0.3625 -0.24165 -0.24165 -0.3625 -0.5375 -0.3625 -0.8875s0.12085 -0.64585 0.3625 -0.8875c0.24165 -0.24165 0.5375 -0.3625 0.8875 -0.3625s0.64585 0.12085 0.8875 0.3625c0.24165 0.24165 0.3625 0.5375 0.3625 0.8875s-0.12085 0.64585 -0.3625 0.8875c-0.24165 0.24165 -0.5375 0.3625 -0.8875 0.3625Zm3.725 -5v-1.975l-1.675 1 -0.75 -1.3 1.675 -0.975 -1.675 -0.975 0.75 -1.3 1.675 1v-1.975h1.5v1.975l1.675 -1 0.75 1.3 -1.675 0.975 1.675 0.975 -0.75 1.3 -1.675 -1v1.975h-1.5Zm5.85 6.275 -1.075 -1.075c0.78335 -0.8 1.39585 -1.7125 1.8375 -2.7375 0.44165 -1.025 0.6625 -2.10415 0.6625 -3.2375 0 -1.13335 -0.22085 -2.2125 -0.6625 -3.2375s-1.05415 -1.94585 -1.8375 -2.7625l1.075 -1.05c0.9 0.96665 1.6125 2.05415 2.1375 3.2625 0.525 1.20835 0.7875 2.47085 0.7875 3.7875 0 1.33335 -0.25415 2.60415 -0.7625 3.8125 -0.50835 1.20835 -1.22915 2.2875 -2.1625 3.2375Z"
      />
    </SvgIcon>
  );
};

(RegexIcon as OverridableComponent<SvgIconTypeMap<object, 'svg'>> & { muiName: string }).muiName =
  'RegexIcon';

export default RegexIcon as OverridableComponent<SvgIconTypeMap<object, 'svg'>> & {
  muiName: string;
};
